import { render } from "./FilterableArticles.vue?vue&type=template&id=856d6014&ts=true"
import script from "./FilterableArticles.vue?vue&type=script&lang=ts"
export * from "./FilterableArticles.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__